"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VerticalExpandingWrapper = exports.TextDataContainer = exports.StyledTooltip = exports.StyledSpecGridRow = exports.StyledGridRow = exports.StyledGridColumnWrapper = exports.StyledGridColumnContent = exports.StyledGridColumn = exports.LightContainer = exports.GroupSpecsWrapper = exports.ExpandingWrapper = exports.DataEntryWrapperItem = exports.DataEntryWrapper = exports.ColorSwatchContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _BaseComponents = require("../StyledComponents/BaseComponents");
var _r10SourceLibrary = require("r10-source-library");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const VerticalExpandingWrapper = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
exports.VerticalExpandingWrapper = VerticalExpandingWrapper;
const DataEntryWrapper = _styledComponents.default.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  align-items: stretch;
  justify-content: center;
`;
exports.DataEntryWrapper = DataEntryWrapper;
const DataEntryWrapperItem = _styledComponents.default.div`
  flex: 1;
  display: flex;
`;
exports.DataEntryWrapperItem = DataEntryWrapperItem;
const LightContainer = (0, _styledComponents.default)((0, _BaseComponents.LightBackground)('div'))`
  text-align: center;
  flex: 1;
`;
exports.LightContainer = LightContainer;
const ExpandingWrapper = _styledComponents.default.div`
  flex: 1;
`;
exports.ExpandingWrapper = ExpandingWrapper;
const TextDataContainer = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;
exports.TextDataContainer = TextDataContainer;
const StyledGridRow = (0, _styledComponents.default)(_r10SourceLibrary.GridRow)`
  min-height: 70px;
  &:nth-child(odd) {
    background-color: #f4f4f4;
  }
`;
exports.StyledGridRow = StyledGridRow;
const StyledGridColumn = (0, _styledComponents.default)(_r10SourceLibrary.GridColumn)`
  min-height: 0;
  &:not(:last-child) {
    border-right: ${props => props.shouldAddTableBorders && '1px solid #bebebe;'};
  }
`;
exports.StyledGridColumn = StyledGridColumn;
const StyledGridColumnContent = (0, _styledComponents.default)(StyledGridColumn)`
  padding: 0;
  word-break: break-word;
`;
exports.StyledGridColumnContent = StyledGridColumnContent;
const StyledGridColumnWrapper = (0, _styledComponents.default)(_r10SourceLibrary.GridColumn)`
  padding: 0;
  text-align: center;
`;
exports.StyledGridColumnWrapper = StyledGridColumnWrapper;
const StyledSpecGridRow = (0, _styledComponents.default)(_r10SourceLibrary.GridRow)`
  align-items: center;
  justify-content: center;
  width: 70%;
`;
exports.StyledSpecGridRow = StyledSpecGridRow;
const GroupSpecsWrapper = _styledComponents.default.div`
  border-top: ${props => !props.removeBorder && '1px solid #bebebe;'};
  border-bottom: ${props => !props.removeBorder && '1px solid #bebebe;'};
`;
exports.GroupSpecsWrapper = GroupSpecsWrapper;
const StyledTooltip = _styledComponents.default.div`
  & span[role='button']:focus,
  & span[role='button']:focus-visible,
  & span[role='button']:focus-within {
    box-shadow: none;
  }
`;
exports.StyledTooltip = StyledTooltip;
const ColorSwatchContainer = _styledComponents.default.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
exports.ColorSwatchContainer = ColorSwatchContainer;